/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Burger from '../icons/Burger';
import Button from './Button';

import styles from '../../../styles/buttons/burger.module.css';

const propTypes = {
    direction: PropTypes.oneOf(['left', 'right']),
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    open: PropTypes.bool,
    disabled: PropTypes.bool,
    short: PropTypes.bool,
    onClick: PropTypes.func,
};

const BurgerButton = ({
    direction = 'right',
    iconClassName = null,
    open = false,
    disabled = false,
    short = false,
    onClick = null,
    className = null,
    ...props
}) => (
    <Button
        className={classNames([
            styles.container,
            {
                [styles.boxed]: !short,
                [styles[direction]]: direction !== null,
                [styles.disabled]: disabled,
                [className]: className !== null,
            },
        ])}
        type="button"
        disabled={disabled}
        onClick={onClick}
        {...props}
    >
        <Burger
            className={classNames([
                styles.burger,
                {
                    [iconClassName]: iconClassName !== null,
                },
            ])}
            open={open}
        />
    </Button>
);

BurgerButton.propTypes = propTypes;

export default BurgerButton;
